import React, { useRef, useMemo } from 'react';
import Galaxy from '../Galaxy';
import './FooterSection.css';
import footerImg from '../../assets/images/footerlogo.webp';
import { FaFacebookF, FaTwitter, FaInstagram } from "react-icons/fa";
const FooterSection = () => {
  const footerRef = useRef(null);

  const galaxyComponent = useMemo(() => (
    <Galaxy 
      mouseRepulsion
      mouseInteraction
      density={1.5}
      glowIntensity={0.5}
      saturation={0.8}
      hueShift={240}
    />
  ), []);

  return (
    <footer ref={footerRef} className="footer-section">
      {/* Galaxy Background */}
      <div className="footer-galaxy-background">{galaxyComponent}</div>
      {/* Blue Overlay */}
      <div className="footer-overlay"></div>

      {/* Content */}
      <div className="footer-content">
        {/* Top: Logo */}
        <div className="footer-logo-container">
          <img src={footerImg} alt="MyNaksh" className="footer-logo-image" loading="lazy" />
        </div>

        {/* Middle */}
        <div className="footer-middle-section">
          {/* Download App Section */}
          <div className="footer-download-container">
            <div className="footer-download-box">
              <label className="footer-download-label">DOWNLOAD APP</label>
              <div className="footer-buttons-wrapper">
                <a 
                  href="https://play.google.com/store/apps/details?id=com.astrology.mynaksh" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="footer-app-button footer-google-play-button"
                >
                  <div className="footer-button-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.61 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
                    </svg>
                  </div>
                  <div className="footer-button-text">
                    <span className="footer-button-title">Get it on Google Play</span>
                  </div>
                </a>
                
                <button 
                  className="footer-app-button footer-apple-store-button"
                  disabled
                >
                  <div className="footer-button-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M18.71,19.5C17.88,20.74 17,21.95 15.66,21.97C14.32,22 13.89,21.18 12.37,21.18C10.84,21.18 10.37,21.95 9.1,22C7.79,22.05 6.8,20.68 5.96,19.47C4.25,17 2.94,12.45 4.7,9.39C5.57,7.87 7.13,6.91 8.82,6.88C10.1,6.86 11.32,7.75 12.11,7.75C12.89,7.75 14.37,6.68 15.92,6.84C16.57,6.87 18.39,7.1 19.56,8.82C19.47,8.88 17.39,10.1 17.41,12.63C17.44,15.65 20.06,16.66 20.09,16.67C20.06,16.74 19.67,18.11 18.71,19.5M13,3.5C13.73,2.67 14.94,2.04 15.94,2C16.07,3.17 15.6,4.35 14.9,5.19C14.21,6.04 13.07,6.7 11.95,6.61C11.8,5.46 12.36,4.26 13,3.5Z"/>
                    </svg>
                  </div>
                  <div className="footer-button-text">
                    <span className="footer-button-title">Coming soon</span>
                  </div>
                </button>
              </div>
            </div>
          </div>

          {/* Links */}
          <div className="footer-links-container">
            <span>Daily Horoscope</span>
            <span>Yesterday Horoscope</span>
            <span>Tomorrow Horoscope</span>
            <div className="footer-links-break"></div>
            <span>✦ Panchang</span>
            <span>✦ Kaal/Laabh</span>
            <span>✦ Horoscope</span>
            <span>✦ Shubh Planner</span>
          </div>

          {/* Social */}
          <div className="footer-social-container">
            <div className="footer-legal-links">
              <a href="/terms.html" className="footer-legal-link">T&C</a>
              <span className="footer-legal-separator">|</span>
              <a href="/privacy.html" className="footer-legal-link">Privacy Policy</a>

            </div>
            <p className="footer-social-text">FOLLOW US FOR MORE</p>
            <div className="footer-social-icons">
              <a href="https://www.facebook.com/profile.php?id=61577160656910" className="footer-social-link">
                <FaFacebookF className="footer-social-icon" />
              </a>
              <a href="https://www.instagram.com/mynakshastrology" className="footer-social-link">
                <FaInstagram className="footer-social-icon" />
              </a>
            </div>
            <div className="footer-contact-info">
              <p className="footer-contact-line">
                Legal address - 1st floor, Hanto Virgo Building, #185/A, 22nd Cross, 3rd Sector, HSR Layout, Bangalore – 560102, Karnataka
              </p>
              <p className="footer-contact-line">
                Email address - <a href="mailto:help@mynaksh.com" className="footer-contact-link">help@mynaksh.com</a>
              </p>
              <p className="footer-contact-line">
                Telephone number - <a href="tel:8050717913" className="footer-contact-link">8050717913</a>
              </p>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="footer-copyright">
          © 2025 ASTROCULTURE SERVICES PVT. LTD.
        </div>
      </div>
    </footer>
  );
};

export default React.memo(FooterSection);
